import {useMemo} from 'react';
import {Chip, Paper} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
    paper: {
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0.5,
        margin: 0,
        minHeight: 60,
    },
    chip: {
        height: 33,
        borderRadius: 3,
        color: '#3F51B5',
        textTransform: 'capitalize',
        fontSize: 16,
        backgroundColor: '#E9ECFF',
    },
    li: {
        margin: 12,
    },
});

interface GoalData {
    key: number;
    label: string;
}

type ClientGoalsProps = {
    investmentGoals: Array<string>;
};

export default function ClientGoals(props: ClientGoalsProps) {
    const {investmentGoals} = props;
    const classes = useStyles();

    const goals = useMemo<Array<GoalData>>(() => {
        if (!investmentGoals) return [];

        return investmentGoals.map((goal, index) => {
            let label = '';
            switch (goal) {
                case 'savings':
                    label = 'Save Cash Tax Efficienty';
                    break;
                case 'incomeReplacement':
                    label = 'Replace Income';
                    break;
                case 'debtPayment':
                    label = 'Pay Off Debt';
                    break;
                case 'healthEmergency':
                    label = 'Cover Health Emergencies';
                    break;
                case 'inheritance':
                    label = 'Provide an Inheritance';
                    break;
                default:
                    break;
            }

            return {key: index, label} as GoalData;
        });
    }, [investmentGoals]);

    return (
        <Paper className={classes.paper} component="ul">
            {goals.map((data) => (
                <li key={data.key} className={classes.li}>
                    <Chip label={data.label} className={classes.chip} />
                </li>
            ))}
        </Paper>
    );
}
